import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
// import IconButton from "@material-ui/core/IconButton";
import Divider from '@material-ui/core/Divider';
import Typography from "@material-ui/core/Typography";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import Slide from "@material-ui/core/Slide";
import DialogTitle from "@material-ui/core/DialogTitle";
import Paper from "@material-ui/core/Paper";
import Box from '@material-ui/core/Box';

import DialogContent from "@material-ui/core/DialogContent";
// import ListItemText from '@material-ui/core/ListItemText';
import IconButton from "@material-ui/core/IconButton";

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import { colors,CardMedia } from "@material-ui/core"
import Grid from "@material-ui/core/Grid";
// import Typography from '@material-ui/core/Typography';
import moment from 'moment'
import { states, sources, periods, mandates, incomes, idTypes, statuses } from '../../utils/data'
import { countries } from '../../utils/countries'
import { nationalities } from '../../utils/nationalities'
import { branches } from '../../utils/branches'
import { Confirm } from './confirm'
import { Questions } from './questions'

const useStyles = makeStyles(theme => ({
  appBar: {
    position: "fixed",
    backgroundColor: '#290131'
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
    fontSize: 13,
    fontWeight: 600,
    //backgroundColor: '',
    // color: theme.palette.text.primary.light
  },
  formID: {
    // marginLeft: theme.spacing(2),
    flex: 1,
    fontSize: 18,
    fontWeight: 600,
    textColor: "#FFFFF"
  },
  title1: {
    color: '#f15a24',
    marginLeft: theme.spacing(2),
    flex: 1,
    cursor: 'pointer'
  },
  root: {
    flexGrow: 1
    // maxWidth: 752,
  },
  icon: {
    marginLeft: theme.spacing(1),
    color: theme.palette.text.primary.light
  },
  demo: {
    backgroundColor: theme.palette.background.paper
  },
  modalTitle: {
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary.light
  },
  table: {
    minWidth: 100,
  },
  details: {
    color: colors.grey[900],
    backgroundColor: colors.lime[500],
    fontWeight: 800,
    fontSize: 13,
    height: 30,
  },
  contacts: {
    color: colors.grey[900],
    backgroundColor: colors.lightBlue[300],
    fontWeight: 800,
    fontSize: 13,
    height: 30,
  },
  value: {
    fontSize: 13,
    fontWeight: 550,
    textTransform: "uppercase",
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export const PreviewModal = ({ fields, errors, onSubmitFunction, depositValue, handleToggleSnackBar }) => {
  const {
    surname,
    branch,
    othersourcesOfIncome,
    currentEmployer,
    zipcode,
    currentRole,
    province,
    workplaceAddress,
    city,
    zone,
    postalOffice,
    otherNumber,
    phone,
    poBox,
    policy,
    depositAccountNames,
    depositAccountNumber,
    telecomName,
    registeredNames,
    registeredNumber,
    village,
    email,
    bankNameDeposit,
    monthlyGrossIncome,
    formID,
    sourcesOfIncome,
    country,
    otherSigningMandate,
    signingMandate,
    // depositValue,
    periodWithWorkplace,
    idType,
    nationality,
    cardNumber,
    gender,
    otherNames,
    maritalStatus,
    accountName,
    accountNumber,
    date,
    expiryDate,
    dateOfBirth,
    alternativeSourceOfIncome,
    nokAddress,
    nokEmail,
    nokName,
    nokPhone,
    nokRelationship,
    //Adding the images for the front and back
    frontImageValueHolder,
    backImageValueHolder,
    signatureImageValueHolder,

    frontImage2ValueHolder,
    backImage2ValueHolder,
    signatureImage2ValueHolder,
    


  } = fields;

  let genderChecker = gender === '' ? 'M' : gender;
  let sourcesOfIncomeChecker = sourcesOfIncome === '' ? 'B' : sourcesOfIncome;
  let periodWithWorkplaceChecker = periodWithWorkplace === '' ? 'L' : periodWithWorkplace;
  let monthlyGrossIncomeChecker = monthlyGrossIncome === '' ? 'B5' : monthlyGrossIncome;
  let signingMandateChecker = signingMandate === '' ? 'A' : signingMandate;
  let idTypeChecker = idType === '' ? 'N' : idType;
  let branchChecker = branch === '' ? '0000' : branch;
  let nationalityChecker = nationality === '' ? 'AF' : nationality;
  let statusChecker = maritalStatus === '' ? 'S' : maritalStatus;
  let countryChecker = country === '' ? 'AF' : country;
  const othersourcesOfIncomeValue = othersourcesOfIncome === '' || sourcesOfIncome === 'B' || sourcesOfIncome === 'S' ? '...... N/A ......' : othersourcesOfIncome;
  const alternativeSourceOfIncomeValue = alternativeSourceOfIncome === '' ? '..............' : alternativeSourceOfIncome;
  const currentRoleValue = currentRole === '' ? '..............' : currentRole;
  const workplaceAddressValue = workplaceAddress === '' ? '..............' : workplaceAddress;
  const otherSigningMandateValue = signingMandate !== "OT" || otherSigningMandate === '' ? '...... N/A ......' : otherSigningMandate;
  const currentEmployerValue = currentEmployer === '' || sourcesOfIncome === 'OT' || sourcesOfIncome === 'B' ? '...... N/A ......' : currentEmployer;

  const bankNameDepositValue = bankNameDeposit !== '' && depositValue === 'b' ? bankNameDeposit : '............';
  const depositAccountNamesValue = depositAccountNames !== '' && depositValue === 'b' ? depositAccountNames : '............';
  const depositAccountNumberValue = depositAccountNumber !== '' && depositValue === 'b' ? depositAccountNumber : '............';
  const telecomNameValue = telecomName !== '' && depositValue === 't' ? telecomName : '............';
  const registeredNamesValue = registeredNames !== '' && depositValue === 't' ? registeredNames : '...........';
  const registeredNumberValue = registeredNumber !== '' && depositValue === 't' ? registeredNumber : '............';

  const branchValue = branches.data.filter(bran => bran.SOL_ID === branchChecker)
  const countryValue = countries.data.filter(country => country.code === countryChecker)
  const nationalityValue = nationalities.data.filter(nation => nation.alpha_2_code === nationalityChecker)
  const genderValue = states.filter(state => state.value === genderChecker)
  const sourcesOfIncomeValue = sources.filter(source => source.value === sourcesOfIncomeChecker)
  const periodWithWorkplaceValue = periods.filter(period => period.value === periodWithWorkplaceChecker)
  const signingMandateValue = mandates.filter(mandate => mandate.value === signingMandateChecker)
  const monthlyGrossIncomeValue = incomes.filter(income => income.value === monthlyGrossIncomeChecker)
  const idTypeValue = idTypes.filter(type => type.value === idTypeChecker)
  const statusValue = statuses.filter(state => state.value === statusChecker)
  const expiryDateValue = expiryDate === '' ? '........' : moment(expiryDate).format('MMMM Do YYYY');
  const dateOfBirthValue = dateOfBirth === '' ? '........' : moment(dateOfBirth).format('MMMM Do YYYY');
  const classes = useStyles();

  function createData(label, value) {
    return { label, value };
  }

  const basic = [
    createData('Branch', branchValue[0].SOL_DESC),
    createData('Account Number', accountNumber),
    createData('Account Name', accountName),
    createData('Date', moment(date).format('MMMM Do YYYY')),
  ];

  const details = [
    createData('Surname', surname),
    createData('Other Names', otherNames),
    createData('Gender', genderValue[0].label),
    createData('Marital Status', statusValue[0].label),
    createData('Date of Birth', dateOfBirthValue),
    createData('Nationality', nationalityValue[0].nationality),
    createData('Country of Residence', countryValue[0].name),
    createData('ID Card Type', idTypeValue[0].label),
    createData('ID Card Number', cardNumber),
    createData('ID Card Expiry Date', expiryDateValue),
  ];

  const contacts = [
    createData('Mobile Phone', `${zipcode} - ${phone}`),
    createData('Other Number', otherNumber),
    createData('P.O.Box Number and location', `${poBox} - ${postalOffice}`),
    createData('Personal Email', email),
  ];

  const nokContacts = [
    createData('Names', nokName),
    createData('Address', nokAddress),
    createData('Email', nokEmail),
    createData('Relationship', nokRelationship),
    createData('Telephone No.', nokPhone),
  ];

  const residentials = [
    createData('State / City / District', city),
    createData('Province / County', province),
    createData('Village', village),
    createData('Zone/ Plot No. / Street ', zone),
  ];

  const employment = [
    createData('Source of Income', sourcesOfIncomeValue[0].label),
    createData('Other source of Income', othersourcesOfIncomeValue),
    createData('Current Role', currentRoleValue),
    createData('Current Employer', currentEmployerValue),
    createData('Monthly Gross Income', monthlyGrossIncomeValue[0].label),
    createData('Period With Work Place', periodWithWorkplaceValue[0].label),
    createData('Signing Mandate', signingMandateValue[0].label),
    createData('Other Signing Mandate', otherSigningMandateValue),
    createData('Work Place Address', workplaceAddressValue),
    createData('Any other Alternative Source Of Income', alternativeSourceOfIncomeValue),
    createData('Policy', <CheckBoxIcon color="secondary" />),
  ];

  const depositBank = [
    createData('Bank Name', bankNameDepositValue),
    createData('Bank Account Name', depositAccountNamesValue),
    createData('Bank Account Number', depositAccountNumberValue),
  ];

  const depositTelecom = [
    createData(' Telecom Name', telecomNameValue),
    createData('Registered Names', registeredNamesValue),
    createData('Registered Number', registeredNumberValue),
  ];

  //Added the images for front and back IDs
  const IdImages = [
    createData('Front Face ID Photo', frontImageValueHolder),
    createData('Back Face ID Photo', backImageValueHolder),
    createData('Digital Signature', signatureImageValueHolder),

    createData('Front Face ID Photo2', frontImage2ValueHolder),
    createData('Back Face ID Photo2', backImage2ValueHolder),
    createData('Digital Signature2', signatureImage2ValueHolder),
    
  ];


  const deposit = bankNameDeposit !== '' && depositValue === 'b' ? depositBank : depositTelecom;
  const BankBoolean = bankNameDeposit === '' || depositAccountNames === '' || depositAccountNumber === '';
  const telecomBoolean = telecomName === '' || registeredNames === '' || registeredNumber === '';
  const depositBoolean = depositValue === 'b' ? BankBoolean : telecomBoolean;
  const signingMandateBoolean = signingMandate === "OT" && ("otherSigningMandate" in errors);
  const sourcesOfIncomeBoolean = sourcesOfIncome === "OT" && ("othersourcesOfIncome" in errors);
  const currentEmployerBoolean = sourcesOfIncome === "S" && ("currentEmployer" in errors);

  const disabledValue = branch === '' || depositValue === '' || village === '' || sourcesOfIncome === '' || policy === false || monthlyGrossIncome === '' || surname === '' ||
    otherNames === '' || idType === '' || monthlyGrossIncome === '' || zone === '' || city === '' || province === '' || expiryDate === '' || date === '' ||
    dateOfBirth === '' || otherNumber === '' || accountName === '' || country === '' || gender === '' || currentRole === '' || nationality === '' ||
    accountNumber.length !== 13 || signingMandate === '' || depositBoolean === true || signingMandateBoolean === true || maritalStatus === '' ||
    sourcesOfIncomeBoolean === true || currentEmployerBoolean === true || workplaceAddress === '' || periodWithWorkplace === '' || phone === '' ||
    email === '' || (nationality === 'UG' && idType !== 'N') || ("accountNumber" in errors) === true || ("email" in errors) === true || ("phone" in errors) === true ||
    ("otherNumber" in errors) === true || ("postalOffice" in errors) === true || ("cardNumber" in errors) === true || ("workplaceAddress" in errors) === true ||
    ("city" in errors) === true || ("nokRelationship" in errors) === true || ("nokAddress" in errors) === true || ("nokEmail" in errors) === true ||
    ("nokName" in errors) === true || ("nokPhone" in errors) === true || frontImageValueHolder==="" || backImageValueHolder==="" || signatureImageValueHolder==="";

  

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    
    <div>
      <Box mb={2} display="flex">
        <Box p={1} flexGrow={2} >
          <Button
            color="secondary"
            disabled={disabledValue}
            fullWidth
            size="large"
            onClick={handleClickOpen}
            variant="contained"
          >

        Preview & Submit&nbsp;

          </Button>
        </Box>
        <Box p={1}>
          <Questions values={fields} depositValue={depositValue} sourcesOfIncome={sourcesOfIncome} signingMandate={signingMandate} policy={policy}
            selectedValue={depositValue} disabledValue={disabledValue} errors={errors} />
        </Box>
      </Box>
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton
              edge="start"
              color={colors.grey[900]}
              onClick={handleClose}
              aria-label="close"
            >
              <ArrowBackIcon />
            </IconButton>
            <Typography variant="h6" className={classes.title1} onClick={handleClose}>
              Back to Edit
            </Typography>
            <Typography variant="h6" className={classes.title1} >
              <span color="secondary" className={classes.formID}>{formID}</span>
            </Typography>
            <Confirm otherNames={otherNames} formIdValue={formID} fields={fields} onhandleSubmit={onSubmitFunction} handleClosePreview={handleClose} handleToggleSnack={handleToggleSnackBar} />
          </Toolbar>
        </AppBar>
        <div className={classes.root}>
          <DialogTitle id="customized-dialog-title">
            <Typography variant="h6" className={classes.modalTitle}>
              Please Preview your information before you submit !
            </Typography>
          </DialogTitle>
          <DialogContent dividers>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <TableContainer component={Paper}>
                  <Table className={classes.table} size="small" aria-label="a dense table">
                    <TableHead>
                      <TableRow>
                        <TableCell variant="button" display="block" gutterBottom className={classes.details} colSpan='2'>Basic Information</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {basic.map((row) => (
                        <TableRow key={row.name}>
                          <TableCell align="left">{row.label}</TableCell>
                          <TableCell className={classes.value} align="left">{row.value}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                    <TableHead>
                      <TableRow>
                        <TableCell variant="button" display="block" gutterBottom className={classes.details} colSpan='2'>&nbsp;Applicant Details</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {details.map((row) => (
                        <TableRow key={row.name}>
                          <TableCell align="left">{row.label}</TableCell>
                          <TableCell className={classes.value} align="left">{row.value}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                    <TableHead>
                      <TableRow>
                        <TableCell variant="button" display="block" gutterBottom className={classes.contacts} colSpan='2'>&nbsp;Contact Details</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {contacts.map((row) => (
                        <TableRow key={row.name}>
                          <TableCell align="left">{row.label}</TableCell>
                          <TableCell className={classes.value} align="left">{row.value}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                    <TableHead>
                      <TableRow>
                        <TableCell variant="button" display="block" gutterBottom className={classes.details} colSpan='2'>&nbsp;Next of Kin Details</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {nokContacts.map((row) => (
                        <TableRow key={row.name}>
                          <TableCell align="left">{row.label}</TableCell>
                          <TableCell className={classes.value} align="left">{row.value}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
              <Grid item xs={12} md={6}>
                <TableContainer component={Paper}>
                  <Table className={classes.table} size="small" aria-label="a dense table">
                    <TableHead>
                      <TableRow>
                        <TableCell variant="button" display="block" gutterBottom className={classes.contacts} colSpan='2'>&nbsp;Current Residential Details</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {residentials.map((row) => (
                        <TableRow key={row.name}>
                          <TableCell align="left">{row.label}</TableCell>
                          <TableCell className={classes.value} align="left">{row.value}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                    <TableHead>
                      <TableRow>
                        <TableCell variant="button" display="block" gutterBottom className={classes.details} colSpan='2'>&nbsp;Employment / Business Details</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {employment.map((row) => (
                        <TableRow key={row.name}>
                          <TableCell align="left">{row.label}</TableCell>
                          <TableCell className={classes.value} align="left">{row.value}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                    <TableHead>
                      <TableRow>
                        <TableCell variant="button" display="block" gutterBottom className={classes.details} colSpan='2'>&nbsp;Deposit Protection Fund</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {deposit.map((row) => (
                        <TableRow key={row.name}>
                          <TableCell align="left">{row.label}</TableCell>
                          <TableCell className={classes.value} align="left">{row.value}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>

              </Grid>

            
            {IdImages.map((row) => (
              <Grid item xs={12} md={6}>
                <TableContainer component={Paper}>
                  <Table className={classes.table} size="small" aria-label="a dense table">
                    <TableHead>
                      <TableRow>
                        <TableCell variant="button" display="block" gutterBottom className={classes.details} colSpan='2'>{row.label}</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>                     
                        <>
                      <TableRow key={row.name}>
                      </TableRow>
                      <CardMedia
                        component="img"
                        src={row.value}
                        alt="Front image"
                        style={{ width: '400px', height: '150px', objectFit: 'fill' }}
                      />
                        </>                       
                        
                    </TableBody>
                  </Table>
                </TableContainer>
                </Grid>
                ))} 
            
            <Grid item xs={12} md={12}>
                  <Typography align="center">
                    Customer Deposits are protected by the Deposit Protection Fund of Uganda.
                  </Typography>

                  <Typography align="center">
                    PostBank is regulated by the Central Bank of Uganda.
                  </Typography>
            </Grid>

            </Grid><br />
            <Divider variant="middle" /><br />
          </DialogContent>
          <Divider variant="middle" />
        </div>
      </Dialog>
    </div>
  );
};

export default PreviewModal;
